<template>
  <div v-if="show">
    <v-tooltip max-width="500">
      <template #activator="{ props: tooltipProps }">
        <span
          v-bind="tooltipProps"
          class="text-xs text-primary text-medium-emphasis inline-flex items-center mt-1"
          style="cursor: pointer"
        >
          <v-icon size="14" class="mr-1">mdi-information-outline</v-icon>
          {{ t("addAccountDialog.pricingHelpLabel") }}
        </span>
      </template>
      <table>
        <thead>
          <tr>
            <th style="background: transparent" class="text-left pr-4 py-1">
              {{ t("addAccountDialog.pricingVolumeHeader") }}
            </th>
            <th style="background: transparent" class="text-left py-1">
              {{ t("addAccountDialog.pricingPriceHeader") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tier in PRO_ACCOUNT_PRICING_TIERS" :key="tier.price">
            <td class="pr-4 py-1">
              <template v-if="tier.max !== null">
                {{
                  t("addAccountDialog.pricingRange", {
                    min: formatAmount(tier.min),
                    max: formatAmount(tier.max),
                  })
                }}
              </template>
              <template v-else>
                {{
                  t("addAccountDialog.pricingAbove", {
                    min: formatAmount(tier.min),
                  })
                }}
              </template>
            </td>
            <td class="py-1">
              {{
                t("addAccountDialog.pricingTierPrice", {
                  price: tier.price,
                  month: t("addAccountDialog.pricingMonth"),
                })
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </v-tooltip>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from "@/composables/useI18n";
import {
  PRO_ACCOUNT_PRICING_TIERS,
  formatProAccountPricingAmount,
} from "@/composables/useProAccountPricing";

defineProps<{
  show: boolean;
}>();

const { t } = useI18n();
const formatAmount = formatProAccountPricingAmount;
</script>
